type ToggleProps = {
	id?: string;
	checked: boolean;
	onChange: (checked: boolean) => void;
	accentColor: string;
	ariaLabel?: string;
};

export function Toggle({
	id,
	checked,
	onChange,
	accentColor,
	ariaLabel,
}: ToggleProps) {
	return (
		<button
			type="button"
			id={id}
			role="switch"
			aria-checked={checked}
			aria-label={ariaLabel}
			onClick={() => onChange(!checked)}
			className="relative inline-flex h-5 w-9 shrink-0 items-center rounded-full border transition-colors cursor-pointer focus:outline-none"
			style={{ borderColor: accentColor, backgroundColor: `${accentColor}26` }}
		>
			<span
				className={`inline-block h-3.5 w-3.5 rounded-full transition-transform ${
					checked ? "translate-x-[18px]" : "translate-x-[2px]"
				}`}
				style={{
					backgroundColor: accentColor,
					filter: checked ? undefined : "brightness(0.7)",
				}}
			/>
		</button>
	);
}
